import type { PageCard } from '@/play/pageTypes'
import { OozeryCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'oozery',
  number: 36,
  title: 'Oozery',
  question: "What does goo cost on the child's own iPad: drizzle and slump goo in a bowl, and the page reports the device and its frame times.",
  status: 'open',
  accent: '#f6efe4',
  CardArt: OozeryCardArt,
}
